import { ChangeEvent, useEffect, useRef, useState } from "react";
import { isValidDate } from '../helpers/Validators'
import { useHistory } from 'react-router-dom';
import '../css/input.css';

export interface EditBirthDayProps {
   onSave: (value: string) => void;
   value?: string | undefined;
   title: string | undefined;
   subtitle: string | undefined;
   buttonText: string;
   value2?: string;
}


const EditBirthdate = ({ onSave, value, title, subtitle, buttonText, value2 }: EditBirthDayProps) => {
   const [day, setDay] = useState<string>("");
   const [month, setMonth] = useState<string>("");
   const [year, setYear] = useState<string>("");
   const [errors, setErrors] = useState<any>({});
   const monthInputRef = useRef<HTMLInputElement>(null);
   const yearInputRef = useRef<HTMLInputElement>(null);
   const dayInputRef = useRef<HTMLInputElement>(null);

   const history = useHistory();

   useEffect(() => {
      if (value) {
         const birthDayArray = value.split('/');
         setDay(birthDayArray[0]);
         setMonth(birthDayArray[1]);
         setYear(birthDayArray[2]);
      } else if (value2) {
         const birthDayArray = value2.slice(0, 10).split('-');
         setDay(birthDayArray[2]);
         setMonth(birthDayArray[1]);
         setYear(birthDayArray[0]);
      }

   }, [])

   const validateForm = () => {
      let errors: any = {};
      let date = `${month}/${day}/${year}`;
      const currentYear = new Date().getFullYear();
      if (day === "" || month === "" || year === "") {
         errors["birthday"] = "התאריך שהקלדת לא תקין";
      } else if (!isValidDate(date)) {
         errors["birthday"] = "התאריך שהקלדת לא תקין, צורת התאריך צריכה להיות dd/mm/yyyy";
      } else if (currentYear - parseInt(year) <= 49) {
         errors["birthday"] = "הקהילה מיועדת לגילאי 50 ומעלה. נשמח לראות אותך שוב בעוד כמה שנים!";
      }

      setErrors(errors);
      return Object.keys(errors).length === 0;
   };

   const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (validateForm()) {
         onSave(`${day}/${month}/${year}`);
         if (history.location.pathname === '/updateBirthdate') {
            history.goBack();
         }
      }
   };

   // const onChangeDay = (value: any) => {
   //     setDay(value)
   //     // if (value.length === 2)
   //     //     monthInputRef.current?.focus();
   // }

   // const onChangeMonth = (value: any) => {
   //     setMonth(value)
   //     // if (value.length === 2)
   //     //     yearInputRef.current?.focus();
   // }

   const autoCompleteDate = () => {
      if (day.length === 1) setDay(prev => "0" + prev);
      if (month.length === 1) setMonth(prev => "0" + prev);
   }

   const onChangeDate = (event: ChangeEvent<HTMLInputElement>, setFn: (value: string) => void, type: string) => {
      switch (type) {
         case 'd':
            if (event.target.value.length === 2) monthInputRef.current?.focus();
            break;
         case 'm':
            if (event.target.value.length === 2) yearInputRef.current?.focus();
            break;
         case 'y':

            break;
         default:
            break;
      }
      const { value, maxLength } = event.target;
      const val = value.slice(0, maxLength);
      setFn(val);
   };




   const enabled =
      day.length > 0 && month.length > 0 && year.length > 0;

   return (
      <>
         <div className="content_sec wf-section">

            <div className="signup_top_info">
               <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
               <h2 className="signup_title">{title}</h2>
               <div>{subtitle}</div>
            </div>
            <div className="login_sec w-form">
               <form onSubmit={handleSubmit}>
                  <div className="form_field_content login">
                     <div className="field_trio_group">
                        <div className="field_block trio">
                           <label htmlFor="name">שנה</label>
                           <input autoComplete="off" value={year} tabIndex={502} maxLength={4} onBlur={autoCompleteDate} onChange={e => onChangeDate(e, setYear, 'y')} ref={yearInputRef} type="number" inputMode='numeric' pattern="[0-9]+" className="txt_field w-input" />
                        </div>
                        <div className="field_block trio">
                           <label htmlFor="month">חודש</label>
                           <input autoComplete="off" value={month} tabIndex={501} maxLength={2} onBlur={autoCompleteDate} onChange={e => onChangeDate(e, setMonth, 'm')} ref={monthInputRef} type="number" inputMode='numeric' pattern="[0-9]+" className="txt_field w-input" />
                        </div>
                        <div className="field_block trio">
                           <label htmlFor="name">יום</label>
                           <input autoComplete="off" value={day} tabIndex={500} maxLength={2} onBlur={autoCompleteDate} onChange={e => onChangeDate(e, setDay, 'd')} ref={dayInputRef} type="number" inputMode='numeric' pattern="[0-9]*" className="txt_field w-input" />
                        </div>
                        <div style={{ display: errors && errors["birthday"] ? "contents" : "block" }} className="form_allert">{errors["birthday"]}</div>
                     </div>
                     <input autoComplete="off" disabled={!enabled} tabIndex={503} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>

                  </div>
               </form>
            </div>
         </div>
      </>
   )

}


export default EditBirthdate;



